import React, { useRef, useState } from "react";
import styles from "./styles/EditProfile.module.scss";
import {
  Button,
  Description,
  Input,
  SubTitle,
} from "../../Components/CustomComponents";
import { IoCamera } from "react-icons/io5";
import {
  useGetProfileQuery,
  useUpdateProfileMutation,
} from "../../Data/services/settingApi";
import { useEffect } from "react";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import ClipLoader from "react-spinners/ClipLoader";

export default function EditProfile() {
  const fileInputRef = useRef(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [imageFile, setImageFile] = useState("");

  const {
    data: profileData,
    isLoading,
    refetch,
  } = useGetProfileQuery({
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (profileData && profileData.data) {
      const { firstname, lastname, email, image_url, name } = profileData.data;
      setFirstName(firstname || "");
      setLastName(lastname || "");
      setEmail(email || "");
      setName(name || "");
      setImagePreview(image_url || null); // Set the image preview if available
    }
  }, [profileData]);

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file)); // Create a preview URL
    }
  };

  const handleFirstName = (e) => {
    setFirstName(e.target.value);
  };
  const handleLastName = (e) => {
    setLastName(e.target.value);
  };

  const [updateProfile, { isLoading: isUpdating }] = useUpdateProfileMutation();

  const handleSubmit = async () => {
    // Handle form submission
    const formData = new FormData();
    formData.append("image_url", imageFile);
    formData.append("firstname", firstName);
    formData.append("lastname", lastName);

    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    try {
      const response = await updateProfile(formData);
      console.log(response);

      if (response?.data?.code === 200) {
        refetch();
        SuccessToast(response?.data?.message);
      }
    } catch (error) {
      console.error("Failed to update profile:", error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  return (
    <div className={styles.EditProfile}>
      <SubTitle text="Edit Profile" />
      <Description
        text="You can edit your profile information here. Please make sure to keep your information up to date."
        classes="fs-8 mb-4"
      />
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center">
          <ClipLoader color="#6457c6" size="22" />
        </div>
      ) : (
        <div className={styles.form}>
          <div className={styles.userImageContainer}>
            <img
              src={imagePreview || "/images/no_image_available.png"}
              alt="User Profile"
              className={styles.userImage}
            />
            <span className={styles.cameraIcon} onClick={handleUploadClick}>
              <IoCamera color="white" />
            </span>
            {/* Hidden file input */}
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: "none" }}
              accept="image/*" // Limit to image files
            />
          </div>
          <SubTitle text={name} classes="fs-5 mt-2" />
          <Description text={email} classes="fs-8 my-1" />
          {/* <Description text="+84 905070017" classes="fs-8 mb-3" /> */}
          <Input
            placeholder="First name"
            value={firstName}
            onChange={handleFirstName}
          />
          <Input
            placeholder="Last name"
            value={lastName}
            onChange={handleLastName}
          />

          <Button
            text={
              isUpdating ? <ClipLoader color="#6457c6" size="22" /> : "Save"
            }
            classes={`fs-6 mb-2 mt-auto mt-3 mb-2 ${
              isUpdating ? "bg-dark-subtle" : ""
            }`}
            disabled={isUpdating}
            onClick={handleSubmit}
          />
        </div>
      )}
    </div>
  );
}
